import { useState, useEffect } from 'react';

const usePincodeLookup = ({
  pincode,
  onSetCity,
  onSetState,
  onSetOptions,
  enableCity = true,
  enableState = true,
  enableOptions = true,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const delayDebounce = setTimeout(async () => {
      if (!pincode || pincode.length !== 6) return;

      setLoading(true);
      try {
        const res = await fetch(
          `https://api.postalpincode.in/pincode/${pincode}`,
          {
            signal: controller.signal,
          }
        );
        const data = await res.json();

        if (data && data[0]?.Status === 'Success') {
          const postOffices = data[0].PostOffice;
          if (postOffices?.length > 0) {
            if (enableOptions && onSetOptions) {
              const options = postOffices.map((po) => ({
                pinCode: po.Pincode,
                district: po.District,
                name: po.Name,
              }));
              onSetOptions(options);
            }

            if (enableCity && onSetCity) {
              onSetCity(postOffices[0].District);
            }

            if (enableState && onSetState) {
              onSetState(postOffices[0].State);
            }
          } else {
            onSetOptions?.([]);
          }
        } else {
          onSetOptions?.([]);
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Pincode fetch error:', err);
          onSetOptions?.([]);
        }
      } finally {
        setLoading(false);
      }
    }, 600); // debounce delay

    return () => {
      clearTimeout(delayDebounce);
      controller.abort();
    };
  }, [pincode]);

  return { loading };
};

export default usePincodeLookup;
